var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * <vitesse-text-input> — themed text field. Single-line by default; set
 * `multiline` for a textarea (used for object/array JSON). Reusable everywhere;
 * size via the `size` attribute (sm | md | lg). Themes automatically.
 *
 *   <vitesse-text-input .value=${s} size="md"
 *       @change=${(e) => (s = e.detail.value)}></vitesse-text-input>
 *   <vitesse-text-input multiline mono rows="6" .value=${json}></vitesse-text-input>
 *
 * Emits a `change` CustomEvent<{ value: string }> on every edit.
 */
let VitesseTextInput = class VitesseTextInput extends LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.multiline = false;
        this.mono = false;
        this.rows = 5;
        this.placeholder = '';
        this.disabled = false;
        this.size = 'md';
    }
    static { this.styles = css `
    :host { display: block; }
    input, textarea {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid var(--border-color-light);
      border-radius: var(--radius, 6px);
      background: var(--bg-primary);
      color: var(--text-primary);
      outline: none;
      font: inherit;
      transition: border-color 0.18s ease;
    }
    /* No user resize handle — multiline height comes from the rows attr / host layout. */
    textarea { resize: none; min-height: 60px; line-height: 1.5; }
    input:focus, textarea:focus { border-color: var(--blue); }
    input::placeholder, textarea::placeholder { color: var(--text-secondary); }
    :host([mono]) input, :host([mono]) textarea {
      font-family: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace;
    }
    :host([disabled]) input, :host([disabled]) textarea { opacity: 0.55; cursor: not-allowed; }

    :host([size='sm']) input, :host([size='sm']) textarea { font-size: 12px; padding: 6px 8px; }
    :host([size='md']) input, :host([size='md']) textarea { font-size: 14px; padding: 10px 12px; }
    :host([size='lg']) input, :host([size='lg']) textarea { font-size: 16px; padding: 12px 14px; }
  `; }
    emit(v) {
        this.value = v;
        this.dispatchEvent(new CustomEvent('change', { detail: { value: v }, bubbles: true, composed: true }));
    }
    render() {
        if (this.multiline) {
            return html `<textarea
        rows=${this.rows}
        placeholder=${this.placeholder}
        ?disabled=${this.disabled}
        .value=${this.value}
        @input=${(e) => this.emit(e.target.value)}
      ></textarea>`;
        }
        return html `<input
      type="text"
      placeholder=${this.placeholder}
      ?disabled=${this.disabled}
      .value=${this.value}
      @input=${(e) => this.emit(e.target.value)}
    />`;
    }
};
__decorate([
    property()
], VitesseTextInput.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], VitesseTextInput.prototype, "multiline", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], VitesseTextInput.prototype, "mono", void 0);
__decorate([
    property({ type: Number })
], VitesseTextInput.prototype, "rows", void 0);
__decorate([
    property()
], VitesseTextInput.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], VitesseTextInput.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], VitesseTextInput.prototype, "size", void 0);
VitesseTextInput = __decorate([
    customElement('vitesse-text-input')
], VitesseTextInput);
export { VitesseTextInput };
//# sourceMappingURL=vitesse-text-input.js.map